// extracted by mini-css-extract-plugin
module.exports = {"root":"ResourceList-module--root--1uo40","list":"ResourceList-module--list--1H22l","item":"ResourceList-module--item--PiyMG"};